(() => {
  // ※ブロックを複数置く可能性もあるので querySelectorAll で回す
  const roots = document.querySelectorAll(".dag-series-products");
  if (!roots.length) return;

  const escapeHtml = (s) =>
    String(s ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");

  const formatMoney = (cents) => {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        const fmt = (window.theme && window.theme.moneyFormat) || "{{amount_with_comma_separator}}";
        return window.Shopify.formatMoney(cents, fmt);
      }
    } catch (_) {}

    return new Intl.NumberFormat("ja-JP", {
      style: "currency",
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "JPY",
      maximumFractionDigits: 0,
    }).format((Number(cents) || 0) / 100);
  };

    const buildSearchUrl = (seriesKey) => {
    return `/search.json?q=${encodeURIComponent(seriesKey)}&type=product&view=json`;
    };

    const fetchProducts = async (seriesKey) => {
    const url = buildSearchUrl(seriesKey);
    const res = await fetch(url, { credentials: "same-origin" });

    if (!res.ok) {
        throw new Error(`search fetch failed: ${res.status}`);
    }

    const json = await res.json();
    return json.products || [];
    };

  const sortProducts = (products) => {
    // 在庫あり優先 → 商品名昇順（安定）
    return [...products].sort((a, b) => {
      const av = a.available ? 0 : 1;
      const bv = b.available ? 0 : 1;
      if (av !== bv) return av - bv;

      const at = (a.title || "").toLowerCase();
      const bt = (b.title || "").toLowerCase();
      if (at < bt) return -1;
      if (at > bt) return 1;
      return 0;
    });
  };

  const renderCard = (p, currentHandle) => {
    const url = p.url || "";
    const title = p.title || "";
    const img = p.image ? p.image.replace(/(\_\d+x\d+)?\.(jpg|jpeg|png|webp)/i, "_360x.$2") : "";
    const price = typeof p.price === "number" ? p.price : null;
    const compare = typeof p.compare_at_price === "number" ? p.compare_at_price : null;
    const available = Boolean(p.available);

    const isCurrent = currentHandle && url.includes(`/products/${currentHandle}`);

    const priceHtml =
      price !== null
        ? `<div class="dag-series-products__price">
            <span class="price-item price-item--regular">${escapeHtml(formatMoney(price))}</span>
            ${
              compare && compare > price
                ? `<span class="price-item price-item--sale">${escapeHtml(formatMoney(compare))}</span>`
                : ""
            }
          </div>`
        : "";

    const stockHtml = `<div class="dag-series-products__stock ${available ? "is-available" : "is-soldout"}">
      ${available ? "在庫あり" : "在庫なし"}
    </div>`;

    return `
      <a class="dag-series-products__card ${isCurrent ? "is-current" : ""}"
         href="${escapeHtml(url)}"
         role="listitem"
         aria-current="${isCurrent ? "true" : "false"}">
        <div class="dag-series-products__thumb">
          ${img ? `<img src="${escapeHtml(img)}" alt="${escapeHtml(title)}" loading="lazy">` : ""}
        </div>
        <div class="dag-series-products__meta">
          <div class="dag-series-products__name">${escapeHtml(title)}</div>
          ${priceHtml}
          ${stockHtml}
        </div>
      </a>
    `;
  };

  roots.forEach(async (root) => {
    const seriesKey = root.dataset.seriesKey;
    const currentHandle = root.dataset.currentHandle;
    const limit = Number(root.dataset.limit || 12);
    const listEl = root.querySelector(".dag-series-products__list");

    if (!seriesKey || !listEl) {
      root.style.display = "none";
      return;
    }

    try {
        const products = await fetchProducts(seriesKey);

        // ① 今見ている商品を除外
        const filtered = products.filter(
        (p) => !(p.url || "").includes(`/products/${currentHandle}`)
        );

        // ② 残りが1件もなければ非表示
        if (!filtered || filtered.length < 1) {
        root.style.display = "none";
        return;
        }

        // ③ 在庫あり優先で並び替え
        const sorted = sortProducts(filtered);

        // ④ 描画
        listEl.innerHTML = sorted
        .map((p) => renderCard(p, currentHandle))
        .join("");

    } catch (e) {
      console.warn("[dag-series-products] error", e);
      root.style.display = "none";
    }
  });
})();
